import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import { DETAILS_ROUTE_PATH as dashboardPath } from 'modules/project/ProjectAreaPage/constants';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import * as constants from './constants';
import usePourPresetGroupsQueries, { PourPresetGroupsQueries } from './usePourPresetGroupsQueries';

const PourPresetGroupsPage = lazyWithSuspense(() => import('./PourPresetGroupsPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  component: withLicenceAndDisclaimer({
    pageDataHook: usePourPresetGroupsQueries,
    Component: makePage<constants.PourPresetGroupsPageParams, [], PourPresetGroupsQueries>({
      WrappedPage: PourPresetGroupsPage,
      titleFn: () => i18n._(constants.TITLE),
      parentTitleFn: () => i18n._('Dashboard'),
      parentPathTemplate: dashboardPath,
    }),
  }),
};

export default page;
